import PropTypes from "prop-types";
import { Button } from "react-aria-components";

import { twMerge } from "../../../helpers/twMerge";

export const ModalButton = ({ className = "", ...props }) => (
	<Button
		className={twMerge(
			"tw-inline-flex tw-cursor-pointer tw-select-none tw-appearance-none tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded tw-border-0 tw-bg-white tw-py-2 tw-pl-40px tw-pr-40px tw-align-middle tw-text-[15px] tw-font-semibold tw-uppercase tw-leading-[26.5px] tw-text-black tw-shadow-md tw-outline-none tw-transition-all tw-duration-200 hover:tw-bg-[#1774ff] hover:tw-text-white focus-visible:tw-ring focus-visible:tw-ring-blue-500/50 disabled:tw-cursor-not-allowed",
			className,
		)}
		{...props}
	/>
);

ModalButton.propTypes = {
	className: PropTypes.string,
};
